import styles from './SignUp.scss';
import { useAuthContext } from '@/hooks/auth';
import { pagesPath } from '@/lib/$path';
import Link from 'next/link';
import { SignUpForm, FormValues as SignUpFormValue } from '@/components/organisms/form/SignUpForm';
import { useRouter } from 'next/dist/client/router';
import { useForm } from 'react-hook-form';
import { useSchoolContext } from '@/hooks/school';

/** organizers/SignUp */
export const SignUp: React.FC = () => {
  const router = useRouter();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<SignUpFormValue>({ reValidateMode: 'onSubmit' });
  const referrer = 'string' === typeof router.query.referrer ? router.query.referrer : '/';
  const signInQuery = { query: { referrer } };

  const authCtx = useAuthContext();
  const { school } = useSchoolContext();

  const signUp = handleSubmit(async (params: Parameters<typeof authCtx.signUp>[0]) => {
    await authCtx.signUp(params);
    router.push(pagesPath.register.request.$url());
  });

  return (
    <main className="sign-up">
      <div className="sign-up__inner">
        <h1 className="sign-up__h1">
          「{school?.name}」<br />
          新規登録
        </h1>
        <SignUpForm onSubmit={signUp} register={register} errors={errors} />
        <ul className="sign-up__menu">
          <li>
            <Link href={pagesPath.sign_in.$url(signInQuery)}>
              <a>ログイン画面へ</a>
            </Link>
          </li>
          <li>
            <Link href={pagesPath.$url()}>
              <a>トップへ戻る</a>
            </Link>
          </li>
        </ul>
      </div>
      <style jsx>{styles}</style>
    </main>
  );
};
